"use strict";

import Vue from 'vue';
import vueCookie from 'vue-cookie'
import moment from 'moment'
import {validateSpecialRBTimer} from '@/js/common/rb-timer'

switch(comp_lang) {
  case 'zh_CN':
    require('moment/locale/zh-cn')
    moment.locale('zh-cn')
    moment.updateLocale('zh-cn', {
      longDateFormat: {
        MM : 'xx'
      }
    })
  break;
  case 'zh_TW':
    require('moment/locale/zh-tw')
    moment.locale('zh-tw')
  break;
  case 'th_TH':
    require('moment/locale/th')
    moment.locale('th')
  break;
  case 'es_MX':
    require('moment/locale/es')
    moment.locale('es')
  break;
  case 'pt_PT':
    require('moment/locale/pt')
    moment.locale('pt')
  break;
  case 'fa_IR':
    require('moment/locale/fa')
    moment.locale('fa')
  break;
  case 'ja_JP':
    require('moment/locale/ja')
    moment.locale('ja')
  break;
  case 'ko_KR':
    require('moment/locale/ko')
    moment.locale('ko')
  break;
  default: //en_US
}

Vue.filter('date', function(value, format) {
  var paramDate = new moment(value)
  return paramDate.format(format);
})

/**
 * Format 
 */
Vue.filter('rb-timer', function(event, format) {
  var timer = ''

  if(event.sptid == '1'){
    var timerSec = moment.duration(event.rbinfo.tlsec,'seconds').seconds()
    var timerMin = moment.duration(event.rbinfo.tlsec,'seconds').minutes()
    var timerHour = moment.duration(event.rbinfo.tlsec,'seconds').hours()

    if(timerSec.toString().length == 1) {
      timerSec = '0' + timerSec
    }

    timer = timerMin
    if(event.rbinfo.htst == '2') {
      if(event.extraflag) { //this is for extra time events
        timer = timerMin >= 15 ? timerMin - 15 : timerMin
      } else {
        timer = ((timerHour * 60) - 45) + timerMin
      }
    }
    
    if(validateSpecialRBTimer(event, timerHour, timerMin)) {
      timer = (timerHour * 60) - 45 + timerMin
    }

    if(timer.toString().length == 1) {
      timer = '0' + timer
    }

    if(format == 'mm:ss') {
      timer += ':' + timerSec
    } else if (format == 'mm') {
      timer = timer
    } else {
      timer += ':' + timerSec
    }

  }else if(event.sptid == '2'){
    var timerMin = event.rbinfo.evetm
    if(timerMin!=null && timerMin.toString().length >= 1) {
      timerMin = (timerMin.toString().length==1) ? '0' + timerMin : timerMin
      timer = timerMin
      if(format == 'mm:ss') {
        timer += ':00'
      } else if (format == 'mm') {
        timer = timer
      } else {
        timer += ':00'
      }
    }
  }
  return timer;
})

Vue.filter('checkTimer', function(event, format) {
  var timer = ''

  if(event.sptid == '1'){
    var timerSec = moment.duration(event.rbinfo.tlsec,'seconds').seconds()
    var timerMin = moment.duration(event.rbinfo.tlsec,'seconds').minutes()
    var timerHour = moment.duration(event.rbinfo.tlsec,'seconds').hours()

    if(timerSec.toString().length == 1) {
      timerSec = '0' + timerSec
    }

    timer = timerMin
    if(event.rbinfo.htst == '2') {
      if(event.extraflag) { //this is for extra time events
        timer = timerMin >= 15 ? timerMin - 15 : timerMin
      } else {
        timer = ((timerHour * 60) - 45) + timerMin
      }
    }
    
    if(validateSpecialRBTimer(event, timerHour, timerMin)) {
      timer = (timerHour * 60) - 45 + timerMin
    }

    if(timer.toString().length == 1) {
      timer = '0' + timer
    }

    if(timer < 0){
      timer = ''
    }else{
      if(format == 'mm:ss') {
        timer += ':' + timerSec
      } else if (format == 'mm') {
        timer = timer
      } else {
        timer += ':' + timerSec
      }
    }

  }else if(event.sptid == '2'){
    var timerMin = event.rbinfo.evetm
    if(timerMin!=null && timerMin.toString().length >= 1) {
      timerMin = (timerMin.toString().length==1) ? '0' + timerMin : timerMin
      timer = timerMin

      if(timer < 0){
        timer = ''
      }else{
        if(format == 'mm:ss') {
          timer += ':00'
        } else if (format == 'mm') {
          timer = timer
        } else {
          timer += ':00'
        }
      }
    }
  }

  return timer;
})



Vue.filter('isPersian', function(stringLanguage) {
  var PersianOrASCII = /[آ-ی]|([a-zA-Z])/;
  var m ="";
  if ((m = stringLanguage.match(PersianOrASCII)) !== null) {
    if (m[1]) {
       return false;
    } else { 
      return true; 
    }
  }else { 
    return true; 
  }
})


// WEBPACK FOOTER //
// ./resources/score/vue/filters/date.js